import { jwtDecode } from "jwt-decode";
import Cookies from "js-cookie";
import { redirectToBattleNetLogin } from "./auth";

const useDecodedToken = () => {
  let token = Cookies.get("jwt") || null;

  // The BattleNet OAuth callback lands on a private route with ?token=...
  // Capture it into the cookie synchronously, right here, so this same
  // render sees the user as logged in immediately. Route guards like
  // PrivateRoute call this hook before the page itself ever mounts, so if
  // the token capture instead lived in a page's effect (as it used to),
  // the guard would redirect back to BattleNet before that effect got a
  // chance to run — an infinite login loop.
  if (!token) {
    const urlToken = new URLSearchParams(window.location.search).get("token");
    if (urlToken) {
      Cookies.set("jwt", urlToken, { path: "/", sameSite: "Lax" });
      token = urlToken;
      window.history.replaceState(null, "", window.location.pathname);
    }
  }

  let decodedJwt = null;

  if (token) {
    decodedJwt = jwtDecode(token);
  } else {
    console.error("No JWT found in cookies");
    redirectToBattleNetLogin();
  }

  return { token, decodedJwt };
};

export default useDecodedToken;
